var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Linking } from 'react-native';
export const SAME_TAB = '_self';
export const NEW_TAB = '_blank';
export default function pushExternalUri({ newTab, uri }) {
    return __awaiter(this, void 0, void 0, function* () {
        const target = newTab ? NEW_TAB : SAME_TAB;
        // @ts-ignore Needed because only RNW's Linking.openUrl takes a second parameter
        yield Linking.openURL(uri, target);
    });
}
//# sourceMappingURL=ExternalLinking.js.map